import React, { useState } from "react";
import { recordShare } from "../share-tracking";

const APP_URL = "https://prayerset.com/";

export default function ShareApp({ onNotice, floating = false, compact = false }) {
  const [pending, setPending] = useState(false);
  const [showLink, setShowLink] = useState(false);

  async function handleShare(event) {
    const menu = event.currentTarget.closest("details");
    setPending(true);
    setShowLink(false);
    try {
      // Native share sheets do not reveal the chosen destination (including Copy).
      // A resolved promise counts an action, not proof the recipient received it.
      if (navigator.share) {
        await navigator.share({
          title: "Pray With Me",
          text: "John 3:16: For God so loved the world, that he gave his only Son, that whoever believes in him should not perish but have eternal life. Share a prayer request, celebrate answered prayers, and find encouragement in a community that prays with you.",
          url: APP_URL,
        });
        void recordShare("native_share");
      } else {
        // Only direct clipboard writes can be classified as copy_link.
        await navigator.clipboard.writeText(APP_URL);
        void recordShare("copy_link");
        onNotice("App link copied. Share it with someone who could use prayer.");
      }
      if (menu) menu.open = false;
    } catch (error) {
      if (error.name !== "AbortError") setShowLink(true);
    } finally {
      setPending(false);
    }
  }

  return <div className={floating ? "floating-share" : compact ? "top-share" : undefined}>
    <button className={floating ? "black-button floating-share-button" : compact ? "top-share-button" : "menu-share-button"} onClick={handleShare} disabled={pending}>
      {(floating || compact) && <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><path d="m8.6 10.5 6.8-4M8.6 13.5l6.8 4" /></svg>}
      {pending ? "Sharing…" : floating ? "Share App" : compact ? "Share" : "Share app"}
    </button>
    {showLink && <div className="share-link-fallback" role="status">
      Copy this link to share:
      <input aria-label="App sharing link" readOnly value={APP_URL} onFocus={event => event.target.select()} />
    </div>}
  </div>;
}
